import { Routes } from '@angular/router';

export const VEHICLE_MODELS_ROUTES: Routes = [
  {
    path: 'vehicle-models',
    loadComponent: () =>
      import('./vehicle-models-list/vehicle-models-list.component')
        .then(m => m.VehicleModelsListComponent),
  },
  {
    path: 'vehicle-models/create',
    loadComponent: () =>
      import('./vehicle-models-form/vehicle-models-form.component')
        .then(m => m.VehicleModelsFormComponent),
  },
  {
    path: 'vehicle-models/edit/:id',
    loadComponent: () =>
      import('./vehicle-models-form/vehicle-models-form.component')
        .then(m => m.VehicleModelsFormComponent),
  },
];
